export default "__VITE_ASSET__$KA5_K$T__"